import React, { FC } from "react";
import { Select } from "antd";
import type { SelectProps } from "antd";
import check from "assets/icons/check-icon.svg";
import clsx from "clsx";

interface SelectDropdownProps extends Omit<SelectProps, "options" | "onChange"> {
  label?: string |number;
  value?: string | number | undefined;
  options: { label: string; value: string | number }[];
  onSelect?: (option: { label: string; value: string | number }) => void; 
  onChange?: (value: string | number) => void; 
}

const SelectDropdown: FC<SelectDropdownProps> = ({
  label,
  options,
  value,
  placeholder,
  className,
  onSelect,
  onChange,
  ...props
}) => {
  return (
    <div className="flex flex-col gap-1.5 w-full">
      {label && <label className="text-base tracking-wide">{label}</label>}
      <Select
        {...props}
        allowClear
        value={value ?? undefined}
        onChange={(selectedValue) => {
          // Call onChange with the raw value (for add-branch, add-client, etc.)
          if (onChange) {
            onChange(selectedValue);
          }
          // Call onSelect with the full option object (for SelectClient, SelectVaccine, etc.)
          if (onSelect) {
            const selectedOption = options.find((opt) => opt.value === selectedValue);
            if (selectedOption) {
              onSelect(selectedOption);
            }
          }
        }}
        options={options?.map((option) => ({
          value: option.value,
          label: (
            <div className="flex justify-between items-center">
              <span>{option.label}</span>
              {value === option.value && (
                <img
                  src={check}
                  alt="selected"
                  className="h-4 w-4 object-contain"
                />
              )}
            </div>
          ),
        }))}
        className={clsx(
          "rounded-lg border border-gray-400 bg-gray-100 text-base h-12",
          className
        )}
        popupClassName="!bg-gray-100 !rounded-lg border-0"
        placeholder={placeholder}
      />
    </div>
  );
};

export default SelectDropdown;